export default "__VITE_ASSET__DIrZEddf__"